<template>
  <div class="list-travel" style="padding-top: 50px" v-wechat-title="$store.state.region.re_name +'-皖云游-线路'">
    <van-nav-bar
      :title="name"
      left-text="返回"
      :right-text="region.RegionName"
      left-arrow
      fixed
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <!-- <template #right>
  <van-icon name="location" size="23" v-show="false"  />
  <span class="van-nav-bar__text">{{region.RegionName}}</span>
</template> -->
    </van-nav-bar>
    <div class="xianlu">
        <van-dropdown-menu active-color="#e95b2d">
            <van-dropdown-item
              @change="dropdownChange1"
              v-model="value1"
              :options="option1"
              :title="title1"
            />
            <van-dropdown-item
              @change="dropdownChange2"
              v-model="value2"
              :options="option2"
              :title="title2"
            />
        </van-dropdown-menu>
       <div v-if="zijiayouList.length>0">
         <!-- 自驾游 -->
        <banner-list
        @detailpage="detailpage"
        :zijiayouList="zijiayouList"
        textFlag
        ></banner-list>
       </div>
       <div v-else>
         <div class="zanwu">
        <img src="@/assets/images/zanwu.png" alt="">
        暂无筛选数据
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer";
import bannerList from "@/components/travel/bannerList.vue";
import { selfdrivinglist } from "@/api/travel";
export default {
  data() {
    return {
      name: "线路",
      zijiayouList: [],
      value1: "0",
      value2: "0",
      title1: '类别',
      title2: '日程',
      v1:0,
      v2:0,
      option1: [
        { text: "全部", value: "0" },
        { text: "亲子", value: "1" },
        { text: "情侣", value: "2" },
        { text: "闺蜜", value: "3" },
        { text: "康养", value: "4" },
        { text: "聚会", value: "5" },
        { text: "研学", value: "6" },
        { text: "团建", value: "7" },
      ],
      option2: [
        { text: "全部", value: "0" },
        { text: "一日游", value: "1" },
        { text: "二日游", value: "2" },
        { text: "三日游", value: "3" },
        { text: "四日游", value: "4" },
        { text: "五日游", value: "5" },
      ],
    };
  },
  computed: {
    region: {
      get() {
        return this.$store.state.region;
      },
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push({
        name: "District",
        params: { id: this.region.id, pinyin: this.region.RegionEnName },
      });
    },
    // 选择触发
    dropdownChange1(e) {
        this.title1 = this.option1[e].text;
        this.v1 = e
        // console.log(this.title1);
        this.isLoding(this.v1,this.v2)
    },
    dropdownChange2(e) {
        this.v2 = e
        this.title2 = this.option2[e].text;
        this.isLoding(this.v1,this.v2)
    },
    isLoding(e1,e2) {
      this.zijiayouList = [];
      selfdrivinglist({
        page: 1,
        RegIdDistrict: this.$route.params.id,
        oneselftype:e1,
        sche_type: e2
      }).then((res) => {
        // console.log(res);
        res.selfdrivinglist.data.forEach((v) => {
          this.zijiayouList.push(v);
        });
      });
    },
    //去自驾游页面
    detailpage(item) {
      this.$router.push({
        name: "RoadTrip",
        params: {
          id: item.id,
        },
      });
    },
  },
  created(){
    this.isLoding(0,0);
  },
  components: {
    Footer,
    bannerList
  },
};
</script>
<style>
     .list-travel .van-nav-bar {
   background-color: rgba(43,178,240,1);
  color: #fff;
    }
.list-travel .van-nav-bar__text ,.list-travel .van-nav-bar .van-icon{ color: #fff; font-size: 16px;}
.list-travel .van-nav-bar__title  { color: #fff; font-size: 18px} 
.pull span{background-color: #f94000;}
.titlebg{ background-color:#000; height:42px; position: absolute; bottom:28px; width:100%;opacity: 0.5;}
.list-travel{ background-color: #fff; }
</style>
<style scoped>
.xianlu{
    margin: 0 6px;
    padding-bottom: 60px;
}
.zanwu{
    margin-top: 20%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #afafaf;
}
.zanwu img{
    width: 100px;
    margin-bottom: 10px;
}
</style>